export default __webpack_public_path__ + "static/media/poster10.7177a0c2.png";